"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DURATION: 250 // ms
};